import React, { memo } from "react";

import { OfferProductDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { MessageBoxPreview } from "@src/features/personalizations/components/offerModifications/widgets/MessageBoxPreview";
import { ProgressBarPreview } from "@src/features/personalizations/components/offerModifications/widgets/ProgressBarPreview";
import { QuantityButtonsPreview } from "@src/features/personalizations/components/offerModifications/widgets/QuantityButtonsPreview";
import { UserInterfaceConfig } from "@src/store/slices/userInterfaces/types";

interface UserInterfacePreviewProps {
  variationId: string;
  config: UserInterfaceConfig;
  hasQuantityButtons: boolean | undefined;
  hasProgressbar: boolean | undefined;
  hasMessageBox: boolean | undefined;
  hideLabel?: boolean;
  renderLocation?: "viewOnly" | "settings";
  offerProducts?: OfferProductDto[];
}

export const UserInterfacePreview = memo(
  ({
    variationId,
    config,
    hasQuantityButtons,
    hasProgressbar,
    hasMessageBox,
    hideLabel,
    renderLocation,
    offerProducts,
  }: UserInterfacePreviewProps) => {
    return (
      <Grid
        item
        container
        direction={"column"}
        className={"user-interface-preview"}
        gap={5}
      >
        {hasQuantityButtons && (
          <QuantityButtonsPreview
            variationId={variationId}
            hideLabel={hideLabel}
            renderLocation={renderLocation}
            offerProducts={offerProducts}
          />
        )}
        {hasProgressbar && (
          <ProgressBarPreview
            variationId={variationId}
            hideLabel={hideLabel}
            renderLocation={renderLocation}
          />
        )}
        {hasMessageBox && (
          <MessageBoxPreview
            variationId={variationId}
            hideLabel={hideLabel}
            renderLocation={renderLocation}
          />
        )}
      </Grid>
    );
  }
);
